<template>
    <div v-if="newsList && newsList.length" class="aside-news">
        <h3 class="aside-news__title">
            <a href="/news-and-media/news/" class="aside-news__title-link">
                {{ title }}
                <z-icon
                    name="form/m/arrow"
                    width="18"
                    height="18"
                    class="aside-news__title-icon"
                    dir="left"
                />
            </a>
        </h3>
        <div class="aside-news__list">
            <news-card
                v-for="card in newsList"
                :key="card.code"
                :card="card"
                class="aside-news__list-card"
            />
        </div>
    </div>
</template>
<script setup>
import { useGetter } from '@/composable/useGetter'
import NewsCard from '@/components/NewsCard/';
import { localize } from '@/utils/i18n.js'

const { app } = useGetter(['app'])

const newsList = app.value.components.news.items
const title = localize({
    ru: 'Новости',
    en: 'News',
    cn: '新闻'
})
</script>

<style lang="scss">
.aside-news{

    &:not(:only-child){
        @include margin-level(top, S);
        @include margin-level(bottom, S);

        &:first-child{
            margin-top: 0;
        }
        &:last-child{
            margin-bottom: 0;
        }
    }

    &__title{
        @include margin-level(bottom, S);
        &-link{
            display: flex;
            align-items: center;
            justify-content: space-between;
            @include typo-level(XL);
            font-weight: 600;
            line-height: 140%;
            color: var(--color-black);
            text-decoration: unset;

            @include breakpoint(tablet){
                justify-content: flex-start;
                @include gap-level(m);
                @include typo-level(2XL);
            }
            @include breakpoint(mobile){
                justify-content: space-between;
                @include typo-level(3XL);
            }
        }

        &-icon{
            padding: 12px;
            width: 42px;
            height: 42px;
            background: var( --color-primary);
            border-radius: 50%;

            & path{
                fill: #ffffff;
            }
        }
    }

    &__list{
        @include breakpoint(tablet){
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            @include gap-level(M);
        }

        &-card{

            @include breakpoint(tablet){
                width: calc(100% / 3 - var(--spacer-m) * 2 / 3);
            }
            @include breakpoint(v-tablet){
                width: calc(100% / 2 - var(--spacer-m)/2);
            }
            @include breakpoint(mobile){
                width: 100%;
            }

            &:not(:last-of-type){
                @include margin-level(bottom, S);

                @include breakpoint(tablet){
                    margin-bottom: 0;
                }
            }
        }

        & .news-card__excerpt{
            display: none;
        }
    }
}
body.green{
    .aside-news__title-link{
        color: var(--color-white);
        & .z-icon{
            background: var(--color-white);
            & path{
                fill: var(--color-primary);
            }
        }
    }
}
</style>
